import BaseModel from "./BaseModel";
import { TspKeyType } from "./tspKeyEnum";

export default class Offer extends BaseModel {
  id: number;
  name: string;
  startDate?: string;
  endDate?: string;
  voucherName: string;
  voucherCode: string;
  tspKey: TspKeyType;
  /// Accounts that the offer is granted to
  accountIds: number[];

  static __dates = ["startDate", "endDate", "updatedAt", "createdAt"];

  constructor(data: any) {
    super(data, Offer.__dates);
    this.id = data.id;
    this.name = data.name;
    this.voucherName = data.voucherName;
    this.voucherCode = data.voucherCode;
    this.startDate = this.__get('startDateAsDate');
    this.endDate = this.__get('endDateAsDate');
    this.tspKey = data.tspKey;
    this.accountIds = data.accountIds;
  }
}
